import { Col, Flex, Text } from 'components/uiKit'

import s from './ProfileItem.module.scss'

type ProfileItemProps = {
  label: string
  children: string
  isVisible?: boolean
}

export const ProfileItem = ({ label, children, isVisible = true }: ProfileItemProps) => {
  if (!isVisible) return null
  return (
    <Flex className={s.ProfileItem}>
      <Col flex={1}>
        <Flex>
          <Text strong>{label}</Text>
        </Flex>
        <Flex className={s.descriptionContainer}>
          <Text type={'secondary'}>{children ? children : '-'}</Text>
        </Flex>
      </Col>
    </Flex>
  )
}
